import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Trophy, UserPlus } from "lucide-react";

interface AdminHeaderProps {
  onAddEliteUser: () => void;
}

export default function AdminHeader({ onAddEliteUser }: AdminHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between mb-8">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={() => navigate("/")}>
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-display font-bold text-foreground">Admin Dashboard</h1>
          <p className="text-sm text-muted-foreground">Manage users and subscriptions</p>
        </div>
      </div>
      <Button onClick={onAddEliteUser} className="gap-2">
        <UserPlus className="w-4 h-4" />
        <Trophy className="w-4 h-4" />
        Add Elite User
      </Button>
    </div>
  );
}
